import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigurationService } from '../../services/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class CallRateCalculationsService {
  constructor(protected http: HttpClient,
    protected configurations: ConfigurationService) {
  }


  save(callRateCalculations: any) {
    return this.http.post(this.configurations.apiAddress + "/api/CallRateCalculations/save", callRateCalculations);
  }

  search() {

    return this.http.get(this.configurations.apiAddress + '/api/CallRateCalculations/search');
  }

  delete(id: number) {
    return this.http.delete(this.configurations.apiAddress + '/api/CallRateCalculations/delete/' + id);
  }

  getById(id: number) {
    return this.http.get(this.configurations.apiAddress + '/api/CallRateCalculations/getById/' + id);
  }

  getAll() {
    return this.http.get(this.configurations.apiAddress + '/api/CallRateCalculations/getAll/');
  }
}
